export const FEATURE_FLAGS = {
  CONSUMER_AO: "new_account_opening",
  BUSINESS_AO: "business_account_opening",
  CONSUMER_STAFF_LED: "staffer_led_ao_consumer",
  BUSINESS_STAFF_LED: "staffer_led_ao_business",
  CONVERT_TO_STAFF_LED: "convert_application_to_staffer_led",
  PRODUCT_BUNDLES: "product_bundles",
  HSA: "hsa",
  IRA: "ira",
  PRODUCT_LIST_MANAGER_V2: "product_list_manager_v2",
  BENEFICIARIES: "cao_beneficiaries",
  BRANDED_CARDS: "cao_branded_cards",
  DEBIT_CARD_MULTIPLE_METHODS: "debit_card_multiple_methods",
} as const;

export const BASE_PATH = "/product_list_manager_v2";

export const PERMISSIONS = {
  VIEW_PRODUCTS: "indigo.view_opening_products",
  CHANGE_PRODUCTS: "indigo.change_opening_products",
  VIEW_BUNDLES: "indigo.view_productbundle",
  ADD_BUNDLES: "indigo.add_productbundle",
  CHANGE_BUNDLES: "indigo.change_productbundle",
} as const;

export const AO_FLOW_CATEGORY = {
  ONLINE: "online",
  STAFF_LED: "staff_led",
} as const;

export const TAB_TYPES = [
  "consumer",
  "business",
  "consumer_staff_led",
  "business_staff_led",
] as const;

export const TAB_LABELS: Record<(typeof TAB_TYPES)[number], string> = {
  consumer: "Consumer online",
  business: "Business online",
  consumer_staff_led: "Consumer staff-led",
  business_staff_led: "Business staff-led",
};

// Maps each tab type to its ao_flow_category and whether it's business
export const TAB_META: Record<
  (typeof TAB_TYPES)[number],
  { aoFlowCategory: "online" | "staff_led"; isBusiness: boolean }
> = {
  consumer: { aoFlowCategory: "online", isBusiness: false },
  business: { aoFlowCategory: "online", isBusiness: true },
  consumer_staff_led: { aoFlowCategory: "staff_led", isBusiness: false },
  business_staff_led: { aoFlowCategory: "staff_led", isBusiness: true },
};

export const ACCOUNT_TYPES = {
  checking: {
    pluralLabel: "Checking accounts",
    singularLabel: "Checking",
  },
  savings: {
    pluralLabel: "Savings accounts",
    singularLabel: "Savings",
  },
  money_market: {
    pluralLabel: "Money markets",
    singularLabel: "Money market",
  },
  certificate_of_deposit: {
    pluralLabel: "Certificates of deposit",
    singularLabel: "Certificate of deposit",
  },
  hsa: {
    pluralLabel: "HSA accounts",
    singularLabel: "HSA",
  },
  ira: {
    pluralLabel: "IRA accounts",
    singularLabel: "IRA",
  },
} as const;

export type ProductCategory = keyof typeof ACCOUNT_TYPES;

export const FORMATTED_BUSINESS_TYPES: Record<string, string> = {
  sole_proprietor: "Sole Proprietor",
  general_partnership: "Partnership",
  llc: "LLC",
  corporation: "Corporation",
  nonprofit: "Non-profit",
};

export const PERSONAL_APP_TYPES = { personal: "personal" } as const;
export const BUSINESS_APP_TYPES = {
  sole_proprietor: "sole_proprietor",
  general_partnership: "general_partnership",
  llc: "limited_liability_company",
  corporation: "corporation",
  nonprofit: "nonprofit",
} as const;
export const ALL_APP_TYPES = { ...PERSONAL_APP_TYPES, ...BUSINESS_APP_TYPES } as const;

export const ALLOWED_PRODUCT_CATEGORIES = Object.keys(ACCOUNT_TYPES) as ProductCategory[];

export const DOWNLOAD_FORMATS = {
  CSV: "csv",
  XLSX: "xlsx",
} as const;

export const VISIBILITY_TOOLTIPS = {
  HIDDEN: "Hidden by default, only shown via Personas or URL parameters.",
  PUBLIC:
    "Shown to all applicants by default, excluded only via Personas or existing member handling.",
} as const;

/*
Constants below are shared across product and bundle forms when validating a field.

`onTouched` validates on the first blur and on every change after, so an error clears while the
field is being corrected. `onBlur` leaves it on screen until the next blur, which reads as a form
that has not noticed the fix.
*/
export const FORM_VALIDATION_MODE = "onTouched" as const;

export const EXCEEDS_CHARACTER_LIMIT = "Exceeds character limit.";
